/**
 * Функция переопределяет страндартные falsy значения.
 *
 * @param obj преверяемый на false значение.
 *
 * @return true - объект имеет значение (включая 0).
 * false - объект не имеет значения.
 */
export function falseExceptZero(obj: any): boolean {
    return !!obj || obj === 0;
}
